import type { ReactNode } from "react";
import { OTTERFOLIO_THEME } from "./theme";

interface Props {
  children: ReactNode;
}

export function OtterfolioLayout({ children }: Props) {
  return (
    <div
      style={{
        background: OTTERFOLIO_THEME.bg,
        color: OTTERFOLIO_THEME.text,
        minHeight: "100vh",
        padding: "24px 28px",
        fontFamily: "-apple-system, system-ui, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 14,
        }}
      >
        {children}
      </div>
    </div>
  );
}
